import { useEffect } from 'react';
import RecurlyService from '../../business/processors/recurly/RecurlyService';
import { useDispatch } from 'react-redux';
var RECURLY_V4_BASE_URL = 'https://js.recurly.com/v4';
var RECURLY_JS_URL = "".concat(RECURLY_V4_BASE_URL, "/recurly.js");
export var importRecurlyJs = function importRecurlyJs(onLoad) {
  var script = document.createElement('script');
  script.src = RECURLY_JS_URL;
  script.async = true;
  script.onload = onLoad;
  document.body.appendChild(script);
  return function () {
    document.body.removeChild(script);
  };
};
var useRecurlyJs = function useRecurlyJs(_ref) {
  var callback = _ref.callback;
  var dispatch = useDispatch();
  useEffect(function () {
    var recurlyClientCleanup = importRecurlyJs(function () {
      new RecurlyService({
        dispatch: dispatch,
        callback: callback
      });
    });
    return recurlyClientCleanup;
  }, []);
};
var Recurly = function Recurly(props) {
  useRecurlyJs(props);
  return null;
};
export default Recurly;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/Recurly.js
// module id = 4605
// module chunks = 11